import { render } from "./IconEdit.vue?vue&type=template&id=c26d6a8e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c26d6a8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c26d6a8e', __exports__)) {
    api.reload('c26d6a8e', __exports__)
  }
  
  module.hot.accept("./IconEdit.vue?vue&type=template&id=c26d6a8e", () => {
    api.rerender('c26d6a8e', render)
  })

}


export default __exports__